import {Component, inject, Input} from '@angular/core';
import {NbButtonModule, NbCardModule, NbDialogRef} from '@nebular/theme';
import {Environment} from '../../interfaces/Environment';

import {TuiIcon} from '@taiga-ui/core'
import {TuiAutoFocus} from '@taiga-ui/cdk'
import {translations} from '../../translations.ru'

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrl: './error-dialog.component.scss',
  imports: [
    NbCardModule,
    NbButtonModule,
    TuiIcon,
    TuiAutoFocus
]
})
export class ErrorDialogComponent {

  @Input() description: string;
  @Input() err;

  environment = inject(Environment);

  constructor(
    protected ref: NbDialogRef<ErrorDialogComponent>
  ) {
  }

  getErrorText(): string {
    if (typeof this.err === 'string') {
      return this.err;
    }

    if (this.description) {
      return this.description;
    }

    if (this.err && this.err.error && this.err.error.data) {
      return this.err.error.data;
    }

    return translations.uncheckedError;
  }

  dismiss() {
    this.ref.close();
  }
}
